/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { UserStatus } from '../../data/api/users/usersClient.typings';
import { UserRole } from '../../data/api/users/usersClient.typings';
import { UserTableData } from '../../screens/SystemScreens/AdminUsersListScreen/AdminUsersListConfig';

export const MAIN_ROLES: UserRole[] = [
    UserRole.Inspector,
    UserRole.Operator,
    UserRole.Taxpayer,
    UserRole.RegionalInspector,
    UserRole.CentralInspector,
];

export const ADDITIONAL_ROLES: UserRole[] = [UserRole.Director, UserRole.Expert, UserRole.Auditor];

export const isMainRole = (role: UserRole): boolean => {
    return MAIN_ROLES.includes(role);
};

export const isAdditionalRole = (role: UserRole): boolean => {
    return ADDITIONAL_ROLES.includes(role);
};

export const getMainRole = (roles: UserRole[]): UserRole | undefined => {
    return roles.find(isMainRole);
};

export const getAdditionalRoles = (roles: UserRole[]): UserRole[] => {
    const mainRole = getMainRole(roles);

    if (mainRole !== UserRole.Inspector) {
        return [];
    }
    return roles.filter(isAdditionalRole);
};

export const hasUserRole = (roles: UserRole[], role: UserRole): boolean => {
    return roles.includes(role);
};

export const isTaxInspectorRights = (userRoles: UserRole[]): boolean => {
    return (
        userRoles.includes(UserRole.Inspector) ||
        userRoles.includes(UserRole.Expert) ||
        userRoles.includes(UserRole.Director) ||
        userRoles.includes(UserRole.Auditor) ||
        userRoles.includes(UserRole.CentralInspector) ||
        userRoles.includes(UserRole.RegionalInspector)
    );
};

export const isOperatorRights = (userRoles: UserRole[]): boolean => {
    return userRoles.includes(UserRole.Operator);
};

export const areDeletedUsersShown = (tableData: UserTableData[]): boolean => {
    for (let i = 0; i < tableData.length; i++) {
        if (tableData[i].status === UserStatus.Deleted) return true;
    }
    return false;
};
